import { atom } from "jotai";
import { Defaults, Section } from "./enums";

export const UserId = atom(Defaults.Nullable);
export const BookId = atom(Defaults.GuidEmpty);
export const SearchBooks = atom({ booksLite: Defaults.ArrayEmpty, totalItems: Defaults.Number, hiddenOnPage: Defaults.Number });
export const LastHomeSegment = atom(Section.Search);
export const Loading = atom(false);
